const setWidth = () => {
  const header = document.querySelector('.header-image')
  if (header) {
    const gap = 30
    const img = header.querySelector('.header-image__image-wrapper')

    if (!img) {
      return
    }

    const imgWidth = img.clientWidth
    const imgEl = img.querySelector('img')

    if (window.matchMedia('(max-width: 991.98px)').matches) {
      imgEl.style.width = `calc(var(--space-width) + ${imgWidth}px)`
    } else {
      imgEl.style.width = `calc(var(--space-width) + ${imgWidth}px - ${gap}px)`
    }
  }
}

setWidth()
window.addEventListener('load', setWidth)
window.addEventListener('resize', setWidth)
